import React, {Component, Fragment, ReactNode} from "react";
import {CloseIcon} from "@App/Components/common/Icons";
import {Transition} from "@headlessui/react"

type PopupProps = {
    title: String,
    open: boolean
    onClose: () => void
    onConfirm: () => void
    children?: ReactNode
};


export class BottomSheet extends Component<PopupProps, {}> {

    public static defaultProps = {
        open: false
    }

    render(): ReactNode {
        return (
            <Transition as={Fragment} show={this.props.open}
                        appear={true}
                        enter="transform transition ease-in-out duration-100"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transform transition ease-in-out duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0">
                <div
                    className={`fixed bg-black-500 z-20 w-screen h-screen top-0 left-0 overflow-hidden`}
                    onClick={this.props.onClose}>
                    <Transition as={Fragment} show={this.props.open}
                                appear={true}
                                enter="transform transition ease-in-out duration-300"
                                enterFrom="translate-y-full"
                                enterTo="translate-y-0"
                                leave="transform transition ease-in-out duration-300"
                                leaveFrom="translate-y-0"
                                leaveTo="translate-y-full">

                        <div data-testid="popup"
                             className={`fixed bottom-0 left-0 w-full p-6 shadow-reverse z-20 bg-white rounded-t`}
                             onClick={(e) => e.stopPropagation()}>
                            <div className="flex justify-between mb-4">
                                <div className="font-bold text-lg font-serif">{this.props.title}</div>
                                <div data-testid="closebutton" onClick={this.props.onClose}>
                                    <CloseIcon/>
                                </div>
                            </div>
                            <div className="mb-4 sm:mb-8">
                                {this.props.children}
                            </div>
                            <div>
                                <div
                                    className="w-full bg-primary px-8 py-2 mt-2 text-white rounded text-center font-bold font-serif"
                                    onClick={this.props.onConfirm}>
                                    Ergebnisse anzeigen
                                </div>
                                <div
                                    className="w-full bg-white px-8 py-2 mt-2 text-primary rounded text-center border font-serif border-primary font-bold"
                                    onClick={this.props.onClose}>
                                    Abbrechen
                                </div>
                            </div>
                        </div>
                    </Transition>
                </div>
            </Transition>
        );
    }
    }
